import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes';


// 라우터 정의
Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: routes
});

// transition 변경 예정
// router.beforeEach((to, from, next) => {
//   from.meta.transition = "slide-enter";
//   to.meta.transition = 'slide-leave';
//   next();
// });

export default router;
